<template>
  <gj-modal
      v-bind="$attrs"
      size="normal"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="$emit('cancel')"
      @confirm="confirm()">
    <template #header>调整竞价</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <el-form-item
            prop="bid.value"
            :rules="[
              { required: true, message: '请输入调整值', trigger: ['blur', 'change'] },
              $gjReRule(RE.num(2), '请输入最多2位小数的正整数')
            ]">
          <gj-select-input
              v-model="form.bid"
              :options="options"
              :width="['160px', '150px']"
              :placeholder="['', '请输入']">
            <template #suffix>
              <span class="gj-input-suffix_icon">{{ icon }}</span>
            </template>
          </gj-select-input>
        </el-form-item>
      </el-form>
      <gj-import-alert
          style="border: none;"
          :rules="alertRules">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, modalMixIn} from "../../../../../../minxins";
  import {transformToMap} from "../../../../../../utils/common";

  export default {
    name: "app-adjust-bid-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      currencySymbol: {
        type: String,
        default: null
      },
      alertRules: {
        type: Array,
        default: ()=> [
          '选择将竞价调整：直接输入目标竞价',
          '按百分比提高/降低竞价公式：目标竞价 = 原始竞价 * ( 100 ± 输入值) / 100',
          '按固定金额提高/减低竞价公式：目标竞价 = 原始竞价 ± 输入值',
          '竞价调整低于0.02或大于1000金额时，系统会将竞价调整为0.02或1000',
          '竞价调整四舍五入精确到小数点后两位数',
        ]
      }
    },
    created() {
      this.options = [
        {id: 0, text: '将竞价调整到', icon: this.currencySymbol},
        {id: 1, text: '按百分比提高竞价', icon: '%'},
        {id: 2, text: '按百分比降低竞价', icon: '%'},
        {id: 3, text: '按固定金额提高竞价', icon: this.currencySymbol},
        {id: 4, text: '按固定金额降低竞价', icon: this.currencySymbol},
      ];
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          bid: {
            key: 0,
            value: null
          }
        },
        options: []
      }
    },
    computed: {
      icon() {
        const option = transformToMap(this.options)[this.form.bid.key];
        return option ? option.icon : '';
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.$emit('confirm');
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .el-form-item__error {
    padding-left: 160px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  /deep/ .el-input__suffix{
    right: 1px;
    top: 1px;
  }
  /deep/ .el-input__suffix-inner{
    height: calc(100% - 2px);
    width: 30px;
    display: inline-block;
  }
  .gj-input-suffix_icon{
    display: inline-block;
    height: 100%;
    width: 100%;
    background: #EEEFF0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/.gj-alert-warning--border {
    border: 0;
  }
</style>
